import { AxiosResponse } from "axios";
import api from "../api";
import {
  AddEmployeeContributionAPI,
  APIContribution,
} from "../types/contributions";

export const addEmployeeContributionAPI = async (
  contributions: AddEmployeeContributionAPI,
): Promise<AxiosResponse<unknown>> => {
  return await api.post(`/Employee/Contribution`, contributions);
};

export const addBeneficiaryContributionsAPI = async (
  contributions: APIContribution[],
  auth: {
    userAccountID: string;
    employeeID: string;
    sootchyEmployerID: string;
  },
): Promise<AxiosResponse<unknown>> => {
  if (
    !contributions ||
    contributions.length === 0 ||
    !auth ||
    !auth.userAccountID ||
    !auth.employeeID
  ) {
    throw new Error("addContributions: Missing required parameters");
  }

  const formattedContributions = contributions.map((contribution) => ({
    userAccountID: auth.userAccountID,
    employeeID: auth.employeeID,
    sootchyEmployerID: parseInt(auth.sootchyEmployerID),
    employeeMinorContribution: contribution.employeeMinorContribution, //percent
    employeeMinorContributionInDollar:
      contribution.employeeMinorContributionInDollar, //dollar
    employerMinorContribution: contribution.employerMinorContribution, //pereent
    employerMinorContributionInDollar:
      contribution.employerMinorContributionInDollar, //dollar
    isEmployeeMinorContributionInPercent:
      contribution.isEmployeeMinorContributionInPercent,
    isEmployerMinorContributionInPercent:
      contribution.isEmployerMinorContributionInPercent,
    minorAccountID: contribution.minorAccountID,
    createdUserAccountID: auth.userAccountID,
    sourceProcess: "WebApplication",
    changeReason: "Adding contribution",
  }));

  return await api.post("/Employee/AddContribution", formattedContributions);
};

export const updateContributions = async (
  contributions: APIContribution[],
  auth: { userAccountID: string; employeeID: string },
): Promise<AxiosResponse<unknown>> => {
  if (
    !contributions ||
    contributions.length === 0 ||
    !auth ||
    !auth.userAccountID ||
    !auth.employeeID
  ) {
    throw new Error("updateContributions: Missing required parameters");
  }

  const formattedContributions = contributions.map((contribution) => ({
    userAccountID: auth.userAccountID,
    employeeID: auth.employeeID,
    // sootchyEmployerID: auth.employeeID,
    sootchyEmployerID: "98", // TODO: Hard coding for now - remove later
    employeeMinorContribution: contribution.employeeMinorContribution,
    employerMinorContribution: contribution.employerMinorContribution,
    isEmployeeMinorContributionInPercent:
      contribution.isEmployeeMinorContributionInPercent,
    isEmployerMinorContributionInPercent:
      contribution.isEmployerMinorContributionInPercent,
    minorAccountID: contribution.minorAccountID,
    createdUserAccountID: auth.userAccountID,
    sourceProcess: "WebApplication",
    changeReason: "Updating contribution",
  }));

  return await api.put("/Employee/EditContribution", formattedContributions);
};

export const fetchAllContributions = async (
  employeeID: string,
  userAccountID: string,
) => {
  return await api.get(
    `/Employee/EmployeeID/${employeeID}/UserAccountID/${userAccountID}`,
  );
};

export const fetchEmployeeContributionData = async (
  employeeID: string,
  userAccountID: string,
) => {
  return await api.get(
    `/Employee/Contribution/${employeeID}/UserAccountID/${userAccountID}`,
  );
};

export const fetchEmployeeBeneficiaryContributionData = async (
  userAccountID: string,
  employeeID: string,
) => {
  return await api.get(
    `/Employee/Minor/Contribution/${userAccountID}/${employeeID}`,
  );
};
